import { Alert, Container } from 'react-bootstrap';
import { Navigate, useParams } from 'react-router-dom';
import { ROUTES } from '../../../../routes/routes';
import { QuestionnaireStatistics } from '../../../questionnaire/components/QuestionnaireStatistics';
import { SurveyDetailTabs, SurveyHeader } from '../../components';
import { useSurveyAnswers, useSurveyDetail } from '../../hooks/useSurveyAdminData';

export default function SurveyStatisticsPage() {
  const { surveyId: surveyIdParam } = useParams();
  const { survey, surveyId, isNew, error } = useSurveyDetail(surveyIdParam);
  const { answers, isLoading, error: answersError } = useSurveyAnswers(surveyId);

  if (isNew) {
    return <Navigate to={ROUTES.survey.settings('new')} replace />;
  }

  return (
    <Container fluid className="p-4">
      <SurveyHeader survey={survey} />
      {surveyId && <SurveyDetailTabs surveyId={surveyId} />}
      {error && <Alert variant="danger">{error}</Alert>}
      {answersError && <Alert variant="danger">{answersError}</Alert>}
      <QuestionnaireStatistics
        questions={survey?.latestVersion?.schema.questions ?? []}
        responses={answers}
        isLoading={isLoading}
      />
    </Container>
  );
}
